import { Controller } from "@hotwired/stimulus";

import browserUpdate from "browser-update";

// Connects to data-controller="browser-update"
export default class extends Controller {
	static targets = ["container"];
	static values = { labels: Object }; // the browser-update lib's `text:` keys

	connect() {
		this.browserUpdate = new browserUpdate({
			required: {
				e: -10, // https://learn.microsoft.com/en-us/deployedge/microsoft-edge-release-schedule
				f: -20, // https://www.mozilla.org/en-US/firefox/releases/
				o: -3,
				s: -1,
				c: -10,
			},
			// insecure: true,
			unsupported: true,

			// test: true,
			container: this.containerTarget,
			no_permanent_hide: true,
			text: this.labelsValue,
			newwindow: true,
			api: 2022.11,
		});
	}
}
